import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// project imports
import { APP_DEFAULT_PATH } from '../../config';
import useAuth from '@hooks/useAuth';
import { Role } from '@config/types';

// ==============================|| GUEST GUARD ||============================== //

export default function GuestGuard({ children }) {
  const { isLoggedIn, user } = useAuth();
  const role = user?.role;
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (isLoggedIn) {
      const fromPath = location?.state?.from;
      const canUseFromPath = fromPath && !['/', '/landing', '/login'].includes(fromPath);

      navigate(
        canUseFromPath ? fromPath : role === Role.LabAdmin || role === Role.User ? '/reports' : APP_DEFAULT_PATH,
        {
          state: {
            from: ''
          },
          replace: true
        }
      );
    }
  }, [isLoggedIn, navigate, location, role]);

  return children;
}

GuestGuard.propTypes = { children: PropTypes.any };
